import { useQuery } from "@tanstack/react-query";

import { supabase } from "@/integrations/supabase/client";

/** True when the signed-in user holds the admin role. */
export function useIsAdmin() {
  const query = useQuery({
    queryKey: ["is-admin"],
    staleTime: 5 * 60_000,
    queryFn: async (): Promise<boolean> => {
      const { data: auth } = await supabase.auth.getUser();
      if (!auth.user) return false;
      const { data, error } = await supabase.rpc("has_role", {
        _user_id: auth.user.id,
        _role: "admin",
      });
      if (error) return false;
      return Boolean(data);
    },
  });

  return { isAdmin: query.data ?? false, isLoading: query.isLoading };
}
